<script>
	export let width = '200px';
	export let height = '200px';

	let style = `width: ${width}; height: ${height}`;
</script>

<style>
	div {
		display: inline-block;
		margin: 0 auto;
	}
</style>

<div {style}>
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%"
		 height="100%" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
	<g id="Filled_Icon">
		<g>
			<circle cx="4" cy="10" r="1"/>
			<path d="M14.5,8c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S17.257,8,14.5,8z M14.5,16.5c-1.93,0-3.5-1.57-3.5-3.5
				s1.57-3.5,3.5-3.5S18,11.07,18,13S16.43,16.5,14.5,16.5z"/>
			<path d="M21.444,6h-1.635C19.29,4.962,18.648,3,17,3h-5c-1.208,0-1.694,0.926-3.25,3H6V5.5C6,4.701,5.273,4,4.444,4H3.5
				C2.716,4,2.028,4.701,2.028,5.486L2.013,6.028C0.368,6.207,0,7.295,0,8.223v10.388C0,20.13,0.931,21,2.556,21h18.889
				C23.069,21,24,20.13,24,18.611V8.223C24,7.209,23.557,6,21.444,6z M4,12c-1.102,0-2-0.896-2-2c0-1.102,0.898-2,2-2
				c1.103,0,2,0.898,2,2C6,11.104,5.103,12,4,12z M14.5,19c-3.309,0-6-2.691-6-6c0-3.309,2.691-6,6-6c3.308,0,6,2.691,6,6
				C20.5,16.309,17.808,19,14.5,19z"/>
		</g>
	</g>
	<g id="Invisible_Shape">
		<rect fill="none" width="24" height="24"/>
	</g>
	</svg>
</div>